import * as Yup from "yup";

export const activitySchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Nome da atividade muito curto")
        .required("O nome da atividade é obrigatório"),
    description: Yup.string().nullable(),
    color: Yup.string().default("#3b82f6"),
    photoUrl: Yup.string().nullable(),
    order: Yup.number().default(0),
    xp: Yup.number().default(0),
    status: Yup.string().oneOf(["active", "inactive"]).default("active"),
    evaluationSystem: Yup.boolean().default(false),

    // Objetivos (Array de objetos)
    objectives: Yup.array().of(
        Yup.object().shape({
            id: Yup.string().required(),
            name: Yup.string().required("Nome do objetivo é obrigatório"),
            order: Yup.number().default(0),
            xp: Yup.number().default(0),

            // Tópicos (Array de objetos dentro de objetivos)
            topics: Yup.array().of(
                Yup.object().shape({
                    id: Yup.string().required(),
                    name: Yup.string().required("Nome do tópico é obrigatório"),
                    order: Yup.number().default(0),
                    xp: Yup.number().default(0),
                    isFundamental: Yup.boolean().default(false)
                })
            ).default([])
        })
    ).default([])
});
